import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const carouselOnPLPSelector = createSelector(testTargetOffersSelector, offers => offers.carouselOnPLP || Empty.Object);

export { carouselOnPLPSelector };
